import React from "react";
import AppHeader from "./AppHeader";
import AppSidebar from "./AppSidebar";
import '../LandingPage.css';

/**
 * Shared layout wrapper that provides header and sidebar to all pages
 */
export default function AppLayout({ children, signOut, onRefresh, refreshing }) {
  return (
    <div className="landing-page">
      <AppHeader signOut={signOut} onRefresh={onRefresh} refreshing={refreshing} />

      <div className="landing-main-layout">
        <AppSidebar />

        <main className="landing-content" style={{ padding: '24px', overflow: 'auto' }}>
          {children}
        </main>
      </div>
    </div>
  );
}
